module.exports = __webpack_public_path__ + "static/media/favoriteStarOn.844479d7.svg";